import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Action } from '@ngrx/store';
import * as productActions from '../product/product.actions';
import { SoledadProductService } from '../../../shared/services/b2b/product.service';

@Injectable()
export class ProductEffects {
    constructor(private actions$: Actions, private productService: SoledadProductService) {}

    getTotalPrice$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(productActions.ProductActionTypes.DO_GET_TOTAL_PRICE),
            switchMap((action: productActions.DoGetTotalPrice) =>
                this.productService.getProductPrice(action.payload.user, action.payload.item).pipe(
                    map((response) => new productActions.DoGetTotalPriceOK(response)),
                    catchError((error) => of(new productActions.DoGetTotalPriceKO(error)))
                )
            )
        )
    );

    getAlternativeProducts$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(productActions.ProductActionTypes.DO_GET_ALTERNATIVE_PRODUCTS),
            switchMap((action: productActions.DoGetAlternativeProducts) =>
                this.productService.getAlternativeProducts(action.payload.user, action.payload.item).pipe(
                    map((response) => {
                        return new productActions.DoGetAlternativeProductsOK(response);
                    }),
                    catchError((error) => of(new productActions.DoGetAlternativeProductsKO(error)))
                )
            )
        )
    );

    getProductRates$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(productActions.ProductActionTypes.DO_GET_PRODUCT_RATES),
            switchMap((action: productActions.DoGetProductsRates) =>
                this.productService.getProductRates(action.payload.item).pipe(
                    map((response) => new productActions.DoGetProductsRatesOK(response)),
                    catchError((error) => of(new productActions.DoGetProductsRatesKO(error)))
                )
            )
        )
    );

    getProductUPVs$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(productActions.ProductActionTypes.DO_GET_PRODUCT_UPVS),
            switchMap((action: productActions.DoGetProductUPVs) =>
                this.productService.getProductUPVs(action.payload.user, action.payload.item).pipe(
                    map((response) => new productActions.DoGetProductUPVsOK(response)),
                    catchError((error) => of(new productActions.DoGetProductUPVsKO(error)))
                )
            )
        )
    );
}
